import React from 'react';
import { useTranslation } from 'react-i18next';
import Announcements from '../Announcements';

const HomePage = ({ toggleBookDemo }) => {
  const { t } = useTranslation();

  return (
    <div className="home-section">
      <div className="hero-section">
        <div className="rotating-headline">
          {t('hero.aiPowered')}
          <div className="rotating-text-container">
            <div className="rotating-text">
              <div>{t('hero.retailInvestors')}</div>
              <div>{t('hero.institutionalTraders')}</div>
              <div>{t('hero.wealthManagers')}</div>
              <div>{t('hero.financialAdvisors')}</div>
              <div>{t('hero.fundManagers')}</div>
              <div>{t('hero.retailInvestors')}</div>
            </div>
          </div>
        </div>
        <p className="motto">
          {t('hero.motto')}
        </p>
        <div className="hero-buttons">
          <button onClick={toggleBookDemo} className="hero-button primary">{t('hero.bookDemo')} →</button>
          <a href="#/demo" className="hero-button secondary">{t('hero.tryForFree')} →</a>
        </div>
        <div className="enterprise-note">
          <p>{t('hero.empoweringInvestors')}</p>
        </div>
      </div>
      
      <div className="announcements-wrapper">
        <Announcements />
      </div>
    </div>
  );
};

export default HomePage;
